module.exports = Object.freeze({
    get: ['willGet', 'doingGet', 'didGet'],
    count: ['willCount', 'doingCount', 'didCount'],
    create: ['willCreate', 'doingCreate', 'didCreate'],
    update: ['willUpdate', 'doingUpdate', 'didUpdate'],
    remove: ['willRemove', 'doingRemove', 'didRemove']
});
